// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { HcpIntakeResponseModel } from './hcpIntakeResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IntakeIntakeHcpIntakeDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': HcpIntakeResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IntakeIntakeHcpIntakeDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "HcpIntakeResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return IntakeIntakeHcpIntakeDefaultResponse.attributeTypeMap;
    }
}
